import { $api } from '@service/RequestService';
import { DATE_FORMAT } from '@utils/constants';
import { BossPaymentsType } from '@utils/models/BossPayments';
import dayjs from 'dayjs';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { mobileConstats, mobileModels } from '..';

export const useMobilePaymentsV2 = (
  props: {
    type?: string;
    start?: string;
    finish?: string;
    houses?: string[];
  } = {}
) =>
  useQuery<mobileModels.IMobilePaymentsV2[]>({
    queryKey: [mobileConstats.queryKeys.MOBILE_PAYMENTS_V2, props],
    queryFn: async () => {
      const res = await $api.get(
        stringifyUrl({
          url: '/v1/mobile/paymentsV2',
          query: {
            start: dayjs(new Date()).startOf('month').format(DATE_FORMAT),
            finish: dayjs(new Date()).startOf('month').add(1, 'month').add(-1, 'day').format(DATE_FORMAT),
            type: BossPaymentsType.DAY,
            ...props
          }
        })
      );

      return res?.data?.data;
    }
  });
